import React, { useContext } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
  Card, CardContent, Grid, Typography, Avatar,
} from '@material-ui/core';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import GestureIcon from '@material-ui/icons/Gesture';
import BarChartOutlinedIcon from '@material-ui/icons/BarChartOutlined';
import CallSplitOutlinedIcon from '@material-ui/icons/CallSplitOutlined';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import MergeTypeOutlinedIcon from '@material-ui/icons/MergeTypeOutlined';
import WarningOutlinedIcon from '@material-ui/icons/WarningOutlined';
import AppContext from '../../AppContext';


const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
  },
  content: {
    alignItems: 'center',
    display: 'flex',
  },
  title: {
    fontWeight: 700,
  },
  avatar: {
    backgroundColor: theme.palette.info.main,
    height: 56,
    width: 56,
  },
  icon: {
    height: 32,
    width: 32,
  },
  difference: {
    marginTop: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
  },
  differenceIcon: {
    color: theme.palette.info.dark,
  },
  differenceErrorIcon: {
    color: theme.palette.error.dark,
  },
  differenceSuccessIcon: {
    color: theme.palette.success.dark,
  },
  differenceValue: {
    color: theme.palette.info.dark,
    marginRight: theme.spacing(1),
  },
  differenceErrorValue: {
    color: theme.palette.error.dark,
    marginRight: theme.spacing(1),
  },
  differenceSuccessValue: {
    color: theme.palette.success.dark,
    marginRight: theme.spacing(1),
  },
}));

function RestraintReport(props) {
  // const { className, ...rest } = props;
  const {
    className, type, iconType, desc,
  } = props;
  const { state } = useContext(AppContext);
  const classes = useStyles();
  const dataFlag = ['filtered', 'unassigned'].includes(type);
  const restStats = !dataFlag && state.data
    ? state.data.iterations[state.iteration_id][type] : null;
  const prevRestStats = state.data && state.iteration_id !== 0 && !dataFlag
    ? state.data.iterations[state.iteration_id - 1][type] : null;
  const deltaRestraints = !dataFlag ? prevRestStats - restStats : null;
  const icon = () => {
    if (iconType === 'barChart') {
      return <BarChartOutlinedIcon className={classes.icon} />;
    }
    if (iconType === 'warning') {
      return <WarningOutlinedIcon className={classes.icon} />;
    }
    if (iconType === 'merge') {
      return <MergeTypeOutlinedIcon className={classes.icon} />;
    }
    if (iconType === 'info') {
      return <InfoOutlinedIcon className={classes.icon} />;
    }
    return '';
  };
  return (
    <Card
      className={clsx(classes.root, className)}
    >
      <CardContent>
        <Grid
          container
          justify="space-between"
        >
          <Grid item>
            <Typography
              className={classes.title}
              color="textSecondary"
              gutterBottom
              variant="body2"
            >
              {desc}
            </Typography>
            {dataFlag && state.data.data.spectra.map((spectra, idx) => (
                  <React.Fragment>
                    <Typography
		      variant="body1">
		        {state.data.data.spectra[idx].name}:{' '}
                        <Typography
		         variant="body1" display="inline"
		          className={state.data.data.spectra[idx][type].percentage >= 40 ? classes.differenceErrorValue : classes.differenceSuccessValue}
		         >
                          {state.data.data.spectra[idx][type].percentage} %
                        </Typography>
                    </Typography>
                  </React.Fragment>
               ))}
            {dataFlag ?
              <Typography
		   variant="body2"
		   component="a"
		   target="_blank"
		   href={type === "filtered" ? state.data.data.peak_list_filtered : state.data.data.peak_list_unassigned}
               >
              View list of {desc}
            </Typography>
	    :
            <Typography variant="h4">
              {restStats}
            </Typography>
	    }
          </Grid>
          <Grid item>
            <Avatar className={classes.avatar}>
              {icon()}
            </Avatar>
          </Grid>
        </Grid>
        <div className={classes.difference}>

          { !deltaRestraints ? null
            : (deltaRestraints <= 0
              ? (
                <>
                  <ArrowUpwardIcon
                    className={iconType !== 'warning' ? classes.differenceSuccessIcon : classes.differenceErrorIcon}
                  />
                  <Typography
                    className={iconType !== 'warning' ? classes.differenceSuccessValue : classes.differenceErrorValue}
                    variant="body2"
                  >
                    +
                    {' '}
                    {Math.abs(deltaRestraints)}
                  </Typography>
                  <Typography
                    className={classes.caption}
                    variant="caption"
                  >
                    Since last iteration
                  </Typography>
                </>
              )
              : (
                <>
                  <ArrowDownwardIcon
                    className={iconType !== 'warning' ? classes.differenceErrorIcon : classes.differenceSuccessIcon}
                  />
                  <Typography
                    className={iconType !== 'warning' ? classes.differenceErrorValue : classes.differenceSuccessValue}
                    variant="body2"
                  >
                    -
                    {' '}
                    {Math.abs(deltaRestraints)}
                  </Typography>
                  <Typography
                    className={classes.caption}
                    variant="caption"
                  >
                    Since last iteration
                  </Typography>
                </>
              ))}

        </div>
      </CardContent>
    </Card>
  );
}

RestraintReport.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string.isRequired,
  iconType: PropTypes.string.isRequired,
  desc: PropTypes.string.isRequired,
};

export default RestraintReport;
